import { Component, HostListener, HostBinding, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config.service';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';

import { User } from 'app/auth/models';
import { EventEmitterService } from '../../../../../@shared/services/common';

@Component({
  selector: '[core-menu-horizontal-collapsible]',
  templateUrl: './collapsible.component.html'
})
export class CoreMenuHorizontalCollapsibleComponent implements OnInit, OnDestroy {
  coreConfig: any;
  currentUser: User;
  isShow = false;

  // Conditionally add the active classes if UrlInChildren
  @HostBinding('class.active')
  @HostBinding('class.open')
  @HostBinding('class.sidebar-group-active')
  public isActive = false;
   isHostListenerActive: boolean = true;

  @Input()
  item: any;

  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {Router} _router
   * @param {CoreConfigService} _coreConfigService
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private el: ElementRef,
    private _router: Router,
    private _coreConfigService: CoreConfigService,
      private _coreMenuService: CoreMenuService,
      private _eventEmitterService: EventEmitterService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
      this._eventEmitterService.invokeItemRightClickEvent.subscribe(data => {        
          
          if (data) {
              this.isHostListenerActive = false;
              setTimeout(() => {
                  this.isHostListenerActive = true;
              }, 1500);
          }
      });
    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.currentUser = this._coreMenuService.currentUser;
    });

    // Listen for router events and expand
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((event: NavigationEnd) => {
        // Confirm if the urlAfterRedirects can be found in one of the children of this item
        if (this.confirmUrlInChildren(this.item, event.urlAfterRedirects)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      });

    // Check if the url can be found in one of the children of this item
    // Required for onInit case (i.e switching theme customizer menu layout)
    if (this.confirmUrlInChildren(this.item, this._router.url)) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Open
   */
  @HostListener('mouseenter')
  show(): void {
            this.isShow = true;
            this.setSubMenuProp();
            this.setMainDropdownScroll();
        
    }

  /**
   * Close
   */
    @HostListener('mouseleave')
    hide(): void {
        if (this.isHostListenerActive) {
            this.isShow = false;
        }
    }

  /**
   * Set sub-menu properties based on screen size
   *
   */
  setMainDropdownScroll(): void {
    setTimeout(() => {
      let nativeElement = this.el.nativeElement,
        nativeElementChildren = this.el.nativeElement.children[1];
      
      // Ana dropdown için scroll ayarla
      if (!nativeElement.classList.contains('dropdown-submenu')) {
        if (nativeElementChildren) {
          const innerHeight = window.innerHeight,
            dropdownTop = nativeElementChildren.getBoundingClientRect().top;
          
          let maxHeight = Math.min(400, innerHeight - dropdownTop - 25);
          
          // Submenu içerip içermediğini kontrol et
          const hasSubmenu = nativeElementChildren.querySelector('.dropdown-submenu');
          
          // Her durumda scroll ekle
          nativeElementChildren.classList.add('menu-scrollable');
          nativeElementChildren.style.maxHeight = maxHeight + 'px';
          
          // Submenu varsa has-submenu class'ı da ekle
          if (hasSubmenu) {
            nativeElementChildren.classList.add('has-submenu');
          }
        }
      }
    });
  }

  setSubMenuProp(): void {
    setTimeout(() => {
      let nativeElement = this.el.nativeElement,
        nativeElementChildren = this.el.nativeElement.children[1];
      
      // Submenu ise
      if (nativeElement.classList.contains('dropdown-submenu')) {
        if (nativeElementChildren) {
          const innerHeight = window.innerHeight,
            dropdownTop = nativeElementChildren.getBoundingClientRect().top,
            dropdownLeft = nativeElementChildren.getBoundingClientRect().left,
            dropdownWidth = nativeElementChildren.scrollWidth;

          let maxHeight = Math.min(400, innerHeight - dropdownTop - 25);
          
          // Scroll ekle
          nativeElementChildren.classList.add('menu-scrollable');
          nativeElementChildren.style.maxHeight = maxHeight + 'px';
          
          // Ekran kenarı kontrolü - sağ tarafa taşar mı?
          if (dropdownLeft + dropdownWidth > window.innerWidth - 16) {
            nativeElement.classList.add('openLeft');
          } else {
            nativeElement.classList.remove('openLeft');
          }
        }
      }
    });
  }

  /**
   * Confirms if the provided url can be found in one of the given parent's children
   *
   * @param parent
   * @param url
   * @returns {boolean}
   */
  confirmUrlInChildren(parent, url): boolean {
    const children = parent.children;

    // Return false if parent don't have any children
    if (!children) {
      return false;
    }

    // Loop all the children
    for (const child of children) {
      // If children has child (Sub to sub item url)
      if (child.children) {
        // Call function again with child
        if (this.confirmUrlInChildren(child, url)) {
          return true;
        }
      }

      // If child.url is same as provided url
      if (child.url === url || url.includes(child.url)) {
        return true;
      }
    }

    return false;
  }
}
